import ApplicationExistingUser from '@/components/ModalRenderer/components/UK/ApplicationExistingUser';
import ApplicationExpired from '@/components/ModalRenderer/components/UK/ApplicationExpired';
import BankAccountManualApproval from '@/components/ModalRenderer/components/UK/BankAccountManualApproval';
import BankAccountNotSupported from '@/components/ModalRenderer/components/UK/BankAccountNotSupported';
import BankAccountUnableToValidate from '@/components/ModalRenderer/components/UK/BankAccountUnableToValidate';
import ConfirmEndAgreement from '@/components/ModalRenderer/components/UK/ConfirmEndAgreement';
import ConfirmManualDeposit from '@/components/ModalRenderer/components/UK/ConfirmManualDeposit';
import DepositFail from '@/components/ModalRenderer/components/UK/DepositFail';
import DirectDebitSetupFailed from '@/components/ModalRenderer/components/UK/DirectDebitSetupFailed';
import DirectDebitTerms from '@/components/ModalRenderer/components/UK/DirectDebitTerms';
import OverduePayment from '@/components/ModalRenderer/components/UK/OverduePayment';
import PrivacyNotice from '@/components/ModalRenderer/components/UK/PrivacyNotice';
import Reapply from '@/components/ModalRenderer/components/UK/Reapply';
import TermsAndConditions from '@/components/ModalRenderer/components/UK/TermsAndConditions';
import WithdrawalSuccess from '@/components/ModalRenderer/components/UK/WithdrawalSuccess';

const UK = {
  APPLICATION_EXISTING_USER: ApplicationExistingUser,
  APPLICATION_EXPIRED: ApplicationExpired,
  BANK_ACCOUNT_MANUAL_APPROVAL: BankAccountManualApproval,
  BANK_ACCOUNT_NOT_SUPPORTED: BankAccountNotSupported,
  BANK_ACCOUNT_UNABLE_TO_VALIDATE: BankAccountUnableToValidate,
  CONFIRM_END_AGREEMENT: ConfirmEndAgreement,
  CONFIRM_MANUAL_DEPOSIT: ConfirmManualDeposit,
  DEPOSIT_FAIL: DepositFail,
  DIRECT_DEBIT_SETUP_FAILED: DirectDebitSetupFailed,
  DIRECT_DEBIT_TERMS: DirectDebitTerms,
  PRIVACY_NOTICE: PrivacyNotice,
  REAPPLY: Reapply,
  TERMS_AND_CONDITIONS: TermsAndConditions,
  WITHDRAWAL_SUCCESS: WithdrawalSuccess,
  OVERDUE_PAYMENT: OverduePayment,
} as const;

export default UK;
